export default __webpack_public_path__ + "static/media/qrcode-app.9f31d061.svg";